'use strict';

angular.module('recommendationModule', [
    'recomModule',
    'services.authenticatedUser'
]);